import { render, staticRenderFns } from "./message-image-web.vue?vue&type=template&id=02f8fd60&scoped=true"
import script from "./message-image-web.vue?vue&type=script&lang=ts"
export * from "./message-image-web.vue?vue&type=script&lang=ts"
import style0 from "./message-image-web.vue?vue&type=style&index=0&id=02f8fd60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f8fd60",
  null
  
)

export default component.exports